<template>
<MapContainer>

</MapContainer>
</template>

<style lang="scss" scoped>

</style>

<script>
import MapContainer from '@/components/MapContainer.vue'

// Mixin
import {restMap} from '@/components/mixin/restMap.js'
import {restSymbology} from '@/components/mixin/restSymbology.js'
import {vuex} from '@/components/mixin/vuex.js'

export default{
  name: 'home',
  mixins: [restMap, restSymbology, vuex],
  data(){
    return{
      
      }
  },
  components:{
      MapContainer
  },
  computed: {
  },
  props: [],
  methods:{
    reloadSymbologiesOnVisible() {
      if (document.visibilityState === 'visible') this.loadSymbologiesForLayers()
    },
  },
  updated () {
    
  },
  created () {
    //Verificar permisos
    this.$store.getters.getPermissions? true:this.$router.push('/inicio')
    this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
  },
  mounted () {
    // Reset all tool state on every map entry (prevents stale state across navigation)
    this.$store.commit('resetMapToolsSelection')
    // QA-11: la vista previa del administrador muestra el mismo menú de
    // herramientas que verá el usuario del visor. Se lee del endpoint admin
    // porque esta vista no exige tener el mapa asignado.
    this.$store.dispatch('setEnabledMapTools', null)
    var that = this
    this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap)
    .then(function (response) {
        that.$store.dispatch('setEnabledMapTools', response.data.tools || null)
    })
    .catch(function (error) {
        console.log(error)
    })
    // QA-148: la vista previa del admin es la ruta por la que se entra al mapa
    // justo despues de crear una simbologia (pestana "Ver mapa"), asi que necesita
    // la misma carga que VisorViewer.vue o el selector nunca aparece.
    this.getLayersByMap().then(() => {
      this.loadSymbologiesForLayers()
    })
    this.getGeoprocessingsByMap()
    document.addEventListener('visibilitychange', this.reloadSymbologiesOnVisible)
  },

  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.reloadSymbologiesOnVisible)
  },
  
}
</script>
